import React from 'react';
import { AuthProvider } from '../../context/Auth';
import { NotificationProvider } from '../../context/NotificationContext';
import DevAdminLogin from './DevAdminLogin';

interface DevAdminLoginMinimalProps {
  onLogin: () => void;
}

const DevAdminLoginMinimal: React.FC<DevAdminLoginMinimalProps> = ({ onLogin }) => {
  return (
    <NotificationProvider>
      <AuthProvider>
        <DevAdminLogin onLogin={onLogin} />
      </AuthProvider>
    </NotificationProvider>
  );
};

export default DevAdminLoginMinimal;
